import { createRouter, createWebHistory, RouteRecordRaw, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/product',
    name: 'Product',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/Product/Product.vue')
  },
  {
    path: '/message',
    name: 'Message',
    component: () => import(/* webpackChunkName: "about" */ '../components/Product/Message.vue')
  },
  {
    path: '/messageInfo',
    name: 'MessageInfo',
    component: () => import(/* webpackChunkName: "about" */ '../components/Product/messageInfo.vue')
  },
  {
    path: '/TheCase',
    name: 'TheCase',
    component: () => import(/* webpackChunkName: "about" */ '../components/TheCase/TheCase.vue')
  },
  {
    path: '/CardPage',
    name: 'CardPage',
    component: () => import(/* webpackChunkName: "about" */ '../components/TheCase/CardPage.vue')
  },
  {
    path: '/News',
    name: 'News',
    component: () => import(/* webpackChunkName: "about" */ '../components/News/News.vue')
  },
  {
    path: '/NewsMessage',
    name: 'NewsMessage',
    component: () => import(/* webpackChunkName: "about" */ '../components/News/NewsMessage.vue')
  },
  {
    path: '/ContactUs',
    name: 'ContactUs',
    component: () => import(/* webpackChunkName: "about" */ '../components/ContactUs/ContactUs.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  next()
})

export default router
